export default __webpack_public_path__ + "static/media/home-banner-img.5a864659.png";